import React from 'react';
import HomepageSplasheeDWeb from '~images/loggedout/home/dweb-homepage-splashee@2x.png';
import HomepageSplasheeMweb from '~images/loggedout/home/mweb-portrait-homepage-splashee@2x.png';
import HomepageSplasheeTWebP from '~images/loggedout/home/tweb-portrait-homepage-splashee@2x.png';
import HomepageSplasheeTWebL from '~images/loggedout/home/tweb-landscape-homepage-splashee@2x.png';
import SignupContainer from '../SignupContainer/index';
import Image from '../../common/Image';

export const DesktopVideoHead = ({ abTestsDetails}) => {
  // [AI GENERATED CODE] - Initialize state with appropriate image based on screen width
  const getImageForWidth = (width) => {
    if (width >= 1280) return HomepageSplasheeDWeb; // for dweb
    if (width >= 871 && width < 1280) return HomepageSplasheeTWebL; // for tweb landscape
    if (width >= 768 && width < 871) return HomepageSplasheeTWebP; // for tweb portrait
    return HomepageSplasheeMweb; // for mweb
  };
  
  const [showModularImage, setModularImage] = React.useState(getImageForWidth(window.innerWidth));
  
  // [AI GENERATED CODE] - Handle resize to update image based on new screen width
  function handleResize(){
    setModularImage(getImageForWidth(window.innerWidth));
  }
  React.useEffect(()=>{
    //add resize listener
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  },[])
  
    return (
      <>
        <div className="homepage-video-variant-gif-container">
          <div className = "static-image-wrapper">
            <Image src={showModularImage} className='home-banner' alt='home-banner' />
          </div>
        </div>
        <SignupContainer abTestsDetails={abTestsDetails}/>
      </>
    )
}
